import React from 'react'
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider} from "@mui/material";
import {BrowserRouter, Routers, Route, Routes} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminView from './scenes/AdminView';
import Shoppen from './scenes/Store';
import Statistik from './scenes/Statistics';
import Home from './scenes/Home';
import Login from './scenes/Login';
import CreateAccount from './scenes/CreateAccount';
import AuthProvider from './components/AuthProvider';
import AuthRoute from './components/AuthRoute';
import Quotes from './scenes/Quotes';
import Transactions from './scenes/Transactions';
import Profile from './scenes/Profile';

function App() {
  const [theme, colorMode] = useMode();

  return (
    <BrowserRouter>
      <AuthProvider>
        <ColorModeContext.Provider value={colorMode}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
              <Route path='/' element={
                <AuthRoute>
                  <Home/>
                </AuthRoute>
                } />
              <Route path='/baxshoppen' element={
                <AuthRoute>
                  <Shoppen/>
                </AuthRoute>
                } />
              <Route path='/statistik' element={
                <AuthRoute>
                  <Statistik/>
                </AuthRoute>
                } />
              <Route path='/citat' element={
                <AuthRoute>
                  <Quotes/>
                </AuthRoute>
                } />
              <Route path='/profile' element={
                <AuthRoute>
                  <Profile/>
                </AuthRoute>
                } />
              <Route path='/admin' element={
                <AuthRoute admin={true}>
                  <AdminView/>
                </AuthRoute>
                } />
              <Route path='/transactions' element={
                <AuthRoute>
                  <Transactions/>
                </AuthRoute>
                } />
              <Route path='/login' element={<Login/>}/>
              <Route path='/create_account' element={<CreateAccount/>}/>
            </Routes>
          </ThemeProvider>
        </ColorModeContext.Provider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App